import { act } from '@testing-library/react';
import { WildcardMockLink } from 'wildcard-mock-link';
export const ApolloMockLink = new WildcardMockLink([], { addTypename: true, act });
